<template>
  <div>
    <span class="name" v-for="(item,index) in dataList" :key="item[routeName]" @click="onItemClickEvent(item)"><span
      v-if="index>0" class="name">{{ splitSymbol }}</span>{{ item[showName] }}</span>
  </div>
</template>

<script>
export default {
  name: 'CustomCrumbs',
  props: {
    showName: {
      type: String,
      default: 'name'
    },
    routeName: {
      type: String,
      default: 'routeName'
    },
    routeParams: {
      type: Object,
      default: function() {
        return {}
      }
    },
    dataList: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      splitSymbol: '>'
    }
  },
  mounted() {
  },
  methods: {
    onItemClickEvent(item) {
      if (item[this.routeName] && this.$route.name !== item[this.routeName]) {
        const params = this.routeParams ? { ...this.routeParams } : {}
        this.openNewPage(item[this.routeName], params)
      }
    }
  }

}
</script>
<style scoped lang="less">
.name {
  font-size: 20px;
  font-weight: bold;
  color: #444444;
}
</style>